import React, {Fragment, Suspense, useEffect, useState} from 'react';
import '../css/legend.css';
import mapboxgl from 'mapbox-gl';
import {useStore} from "./store";
import BunkerDesc from "./BunkerDesc";
import LoremIpsum from "react-lorem-ipsum";
import {ColorLuminance, t} from "../helpers";
import SatSlider from "./SatSlider";
import {Background, Intro, Onboarding, Help, Impressum} from "./Texts";
import {Version} from "./version";

//const LegendAndControl = React.memo((props) => {
const LegendAndControl = (props) => {

	const map = props.map;

	const [selected, setSelected] = useState(0);
// 	const [show, setShow] = useState('');
	const show = useStore(state => state.show);
	const setShow = useStore(state => state.setShow);
	const [showVersion, setShowVersion] = useState(false);
	const [showTour, setShowTour] = useState(false);
	const builtprogress = useStore(state => state.builtprogress);
	const setBuiltprogress = useStore(state => state.setBuiltprogress);
	const language = useStore(state => state.language);
	const setIsOnboarding = useStore(state => state.setIsOnboarding);

	const setCol1 = () => {
		setSelected(1);
		setBuiltprogress(1);
		map.setLayoutProperty('bunker-circle-p0', 'visibility', 'visible');
		map.setLayoutProperty('bunker-circle-p1', 'visibility', 'visible');
		map.setLayoutProperty('bunker-circle-p2', 'visibility', 'none');
		map.setLayoutProperty('bunker-circle-p3', 'visibility', 'none');
	}

	const setColAll = () => {
		setSelected(2);
		setBuiltprogress(2);
		map.setLayoutProperty('bunker-circle-p0', 'visibility', 'visible');
		map.setLayoutProperty('bunker-circle-p1', 'visibility', 'visible');
		map.setLayoutProperty('bunker-circle-p2', 'visibility', 'visible');
		map.setLayoutProperty('bunker-circle-p3', 'visibility', 'visible');
	}

	const setColNone = () => {
		setSelected(0);
		map.setLayoutProperty('bunker-circle-p0', 'visibility', 'none');
		map.setLayoutProperty('bunker-circle-p1', 'visibility', 'none');
		map.setLayoutProperty('bunker-circle-p2', 'visibility', 'none');
		map.setLayoutProperty('bunker-circle-p3', 'visibility', 'none');
	}

	const [progress, setProgress] = useState(["timeslider", "overview"])
	const Add = progress.map(Add => Add)

//	const sub = useStore.subscribe();

	const [stroke_desc, setStroke_desc] = useState(useStore.getState().stroke_desc);
	const [stroke_sel, setStroke_sel] = useState(useStore.getState().stroke_sel);
	const [colors0, setColors0] = useState(useStore.getState().colors_0);
	const [colors1, setColors1] = useState(useStore.getState().colors_1);
	const [colors2, setColors2] = useState(useStore.getState().colors_2);
	const [colors3, setColors3] = useState(useStore.getState().colors_3);
	const [colors_built, setColors_built] = useState(useStore.getState().colors_built);
	const [colors_notbuilt, setColors_notbuilt] = useState(useStore.getState().colors_notbuilt);

	const [stroke0, setStroke0] = useState(useStore.getState().stroke_0);
	const [stroke1, setStroke1] = useState(useStore.getState().stroke_1);
	const [stroke2, setStroke2] = useState(useStore.getState().stroke_2);
	const [stroke3, setStroke3] = useState(useStore.getState().stroke_3);
	const [stroke_built, setStroke_built] = useState(useStore.getState().stroke_built);
	const [stroke_notbuilt, setStroke_notbuilt] = useState(useStore.getState().stroke_notbuilt);

	useEffect(() => {
//		console.log('useEffect::', useStore.getState())
//		console.log('c1::', stroke_desc)
		setStroke_desc(useStore.getState().stroke_desc)
		setStroke_sel(useStore.getState().stroke_sel)
		setColors0(useStore.getState().colors_0)
		setColors1(useStore.getState().colors_1)
		setColors2(useStore.getState().colors_2)
		setColors3(useStore.getState().colors_3)
		setColors_built(useStore.getState().colors_built)
		setColors_notbuilt(useStore.getState().colors_notbuilt)

		setStroke0(useStore.getState().stroke_0)
		setStroke1(useStore.getState().stroke_1)
		setStroke2(useStore.getState().stroke_2)
		setStroke3(useStore.getState().stroke_3)
		setStroke_built(useStore.getState().stroke_built)
		setStroke_notbuilt(useStore.getState().stroke_notbuilt)

		try {
			map.setPaintProperty('bunker-circle-all', 'circle-color', useStore.getState().colors_built);  //notbuilt
			map.setPaintProperty('bunker-circle-all', 'circle-stroke-color', useStore.getState().stroke_built);  //notbuilt
			map.setPaintProperty('bunker-circle', 'circle-color', useStore.getState().colors_notbuilt); //built
			map.setPaintProperty('bunker-circle', 'circle-stroke-color', useStore.getState().colors_notbuilt); //built
			map.setPaintProperty('bunker-circle-p0', 'circle-color', useStore.getState().colors_0);
			map.setPaintProperty('bunker-circle-p0', 'circle-stroke-color', useStore.getState().stroke_0);
			map.setPaintProperty('bunker-circle-p1', 'circle-color', useStore.getState().colors_1);
			map.setPaintProperty('bunker-circle-p1', 'circle-stroke-color', useStore.getState().stroke_1);
			map.setPaintProperty('bunker-circle-p2', 'circle-color', useStore.getState().colors_2);
			map.setPaintProperty('bunker-circle-p2', 'circle-stroke-color', useStore.getState().stroke_2);
			map.setPaintProperty('bunker-circle-p3', 'circle-color', useStore.getState().colors_3);
			map.setPaintProperty('bunker-circle-p3', 'circle-stroke-color', useStore.getState().stroke_3);
			map.setPaintProperty('bunker-circle-outline', 'circle-stroke-color', useStore.getState().stroke_sel); //stroke_sel
			map.setPaintProperty('bunker-circle-outline-desc', 'circle-stroke-color', useStore.getState().stroke_desc); //stroke_desc
		} catch (e) {
			//console.log('error:::')
		}
	})

	const handleProgressChange = (e) => {
		//console.log((progress[e.target.value]), e.target.value)
		setIsOnboarding(false)
		let sel = e.target.value;

		switch (sel) {
			case "0":
				setColNone();
				props.legendProgressCallback(true);
				break;
			case "1":
				setColAll();
				props.legendProgressCallback(false);
				break;
		}
	}

	const handleButton = (e) => {
		// console.log("### e", e.target.id)
		setIsOnboarding(false)
		setShowTour(!showTour);
		if (e.target.id == 0) {
			props.legendCallback('Quicktour')
		} else {
			props.legendCallback('finished')
		}
	}

	const callbackSatSlider = (e) => {
		//console.log("e", e)
		setIsOnboarding(false)
		props.satSliderCallback(e)
	}


	const handleLangChange = (d) => {
//		console.log("##",d);
		setIsOnboarding(false)
		useStore.setState({language: d})
		props.langCallback(d);
		// set language to html
		if (d === 'DE') document.documentElement.lang = 'de';
		if (d === 'EN') document.documentElement.lang = 'en';
		if (d === 'IT') document.documentElement.lang = 'it';

	}

	useEffect(() => {
		if (props.quicktourState !== 'Quicktour' && props.quicktourState !== null) {
			setShowTour(false)
		}
	}, [props.quicktourState]);


	useEffect(()=>{
		if (show || showTour) setIsOnboarding(false)
	}, [show, showTour])

	return (
		<>
			<div className={'controlHeader'}>
				<a href="https://franzensfeste.info" target="_blank">
					<img src={'logo-franzensfeste.png'} className={'logo'} height={'50px'}></img>
				</a>
				<div className={'controlContainer'}>
					<div className={'navlink2'} onClick={() => setShow('background')}>{t('VALLO ALPINO')}</div>
					{showTour ?
						<button id='1' className={'controlButton'} onClick={handleButton}>{t('stop quicktour')}</button>
						:
						<button id='0' className={'controlButton'} onClick={handleButton}>{t('quicktour')}</button>
					}
					<div style={{position: 'relative'}}>
						<Onboarding></Onboarding>
					</div>
					<div style={{marginLeft: '20px'}}>{t('construction progress')}:</div>
					<select
						onChange={e => handleProgressChange(e)}
						className="controlSelect">
						{
							Add.map((prog, key) => <option key={"sel_" + key} value={key}>
								{t(prog)}
							</option>)
						}
					</select>
					<div className={'navlink'} onClick={() => setShow('intro')}>{t('intro')}</div>
					{/*<div className={'navlink'} onClick={() => setShow('background')}>{t('background')}</div>*/}
					<div className={'navlink'} onClick={() => setShow('help')}>{t('help')}</div>
					<div className={'navlink'} onClick={() => setShow('impressum')}>{t('impressum')}</div>

					<div>
						<div className={'navlink'} style={{position: 'relative', top: '5px'}}>
								<svg x="0px" y="0px" viewBox="0 0 20 20" width="20px">
									<g>
										<g transform="translate(0.000000, 10.000000) scale(0.00200000,-0.00200000)">
											<path fill="#333333"
											      d="M2396.9,4983.5c-51.7-24.9-339.1-300.8-866-827.7c-676.3-680.2-791.3-804.7-812.4-873.7c-51.7-178.2-90-130.3,1157.3-1379.5C3124.9,655.3,3079,693.6,3253.3,745.3c65.1,19.2,137.9,80.5,360.2,300.8l279.7,275.9l160.9-162.9L4217,996.3l-283.6-283.6l-283.6-283.6l72.8-24.9c457.9-164.8,917.8-505.8,1210.9-900.5c107.3-143.7,291.2-494.3,348.7-659.1l24.9-72.8l356.4,356.4l354.5,354.5l162.9-162.9L6341.9-843l-346.8-348.7c-283.6-287.4-350.6-365.9-371.7-431.1c-51.7-178.2-90-130.3,1157.2-1379.5c1247.3-1247.3,1201.3-1209,1379.5-1157.2c69,21.1,191.6,136,889,831.5c695.5,697.4,810.4,820,831.5,890.9c51.7,176.3,90,130.3-1157.2,1377.6C7474.2,187.8,7520.2,149.5,7345.8,97.7c-65.1-19.2-138-80.5-360.2-300.8L6705.9-479L6545-316.1l-160.9,161l153.3,159c82.4,88.1,180.1,201.2,214.6,254.8c101.5,153.3,139.9,335.3,101.5,469.4c-11.5,40.2,0,63.2,69,139.9c298.9,323.8,275.9,839.2-51.7,1151.5c-132.2,126.5-274,197.4-450.3,226.1c-239.5,40.2-528.8-49.8-685.9-210.8c-70.9-72.8-78.6-74.7-143.7-57.5c-103.5,28.7-245.2,5.7-383.2-63.2c-92-44.1-187.8-122.6-375.5-306.6l-252.9-245.2l-160.9,160.9l-160.9,162.9l346.8,348.7c283.6,287.4,350.6,365.9,371.7,433c51.7,174.4,88.1,130.3-1138.1,1362.3c-756.8,756.8-1140,1128.5-1191.7,1153.4C2550.1,5027.5,2492.7,5027.5,2396.9,4983.5z M2747.5,4056.2l214.6-214.6l-216.5-216.5L2531,3410.5l-220.3,220.3l-220.3,220.3l210.8,210.8c115,115,214.6,210.8,220.3,210.8S2628.7,4174.9,2747.5,4056.2z M2096,3404.7l214.6-214.6l-216.5-216.5L1879.5,2759l-220.3,220.3l-220.3,220.3l210.8,210.8c115,115,214.6,210.8,220.3,210.8C1875.7,3621.2,1977.3,3523.5,2096,3404.7z M3393.2,3410.5l210.8-210.8l-216.5-216.5l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8S3278.2,3525.4,3393.2,3410.5z M4038.9,2333.7l-214.6-216.5l-220.3,220.3l-220.3,220.3l214.6,214.6l216.5,216.5l220.3-220.3l220.3-220.3L4038.9,2333.7z M2741.7,2759l210.8-210.8L2736,2331.8l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8S2626.8,2874,2741.7,2759z M3389.3,1682.2l-216.5-216.5l-210.8,210.8c-115,115-210.8,218.4-210.8,229.9c0,9.6,92,111.1,205,224.2l206.9,206.9l220.3-220.3l220.3-220.3L3389.3,1682.2z M7652.4-848.8l214.6-214.6l-216.5-216.5l-214.6-214.6l-220.3,220.3l-220.3,220.3L7206-843c115,115,214.6,210.8,220.3,210.8C7432.1-632.3,7533.6-730,7652.4-848.8z M6999.1-1498.3l216.5-216.5l-205-205c-113-115-214.6-206.9-226.1-206.9c-11.5,0-115,95.8-229.9,210.8l-210.8,210.8l210.8,210.8c115,116.9,214.6,210.8,220.3,210.8C6778.7-1283.7,6880.3-1381.4,6999.1-1498.3z M8298.1-1494.5l210.8-210.8l-216.5-216.5l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8C8083.5-1283.7,8183.1-1379.5,8298.1-1494.5z M8943.8-2571.3l-214.6-216.5l-220.3,220.3l-220.3,220.3l214.6,214.6l216.5,216.5l220.3-220.3l220.3-220.3L8943.8-2571.3z M7646.7-2145.9l210.8-210.8l-216.5-216.5l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8C7432.1-1935.1,7531.7-2030.9,7646.7-2145.9z M8292.4-3222.7l-214.6-216.5l-220.3,220.3l-220.3,220.3l214.6,214.6l216.5,216.5l220.3-220.3l220.3-220.3L8292.4-3222.7z"/>
											<path fill="#333333"
											      d="M2038.6,392.8c-300.8-47.9-603.5-199.3-682.1-343c-53.7-99.6-42.2-312.3,30.6-526.9c109.2-318.1,337.2-730,603.5-1088.3l116.9-159l111.1,197.3c59.4,107.3,109.2,205,111.1,214.6c0,11.5-42.2,70.9-92,134.1c-235.7,293.1-406.2,580.5-406.2,680.2c0,172.4,308.5,93.9,741.5-189.7c551.8-360.2,1228.1-1030.8,1596-1582.6c291.2-433,385.1-776,214.6-776c-90.1,0-302.7,118.8-563.3,316.1c-134.1,99.6-249.1,182-254.8,182c-13.4,0-325.7-182-367.9-216.5c-30.6-23,24.9-69,327.6-272.1c622.7-413.8,1189.8-607.4,1410.2-479c90.1,53.6,214.6,247.2,274,425.4c208.8,636.1,17.2,1550-471.3,2241.7c-149.5,210.8-454.1,521.2-661,672.5C3462.1,275.9,2686.2,492.4,2038.6,392.8z"/>
											<path fill="#333333"
											      d="M2860.5-1517.5c-26.8-34.5-157.1-249.1-291.2-475.2s-247.2-415.8-251-419.6c-3.8-3.8-19.2,1.9-32.6,13.4c-13.4,11.5-70.9,30.7-126.5,44.1c-277.8,59.4-526.9-151.4-526.9-442.6c0-264.4,185.8-448.3,448.3-448.3c316.1,0,521.2,289.3,421.5,592c-13.4,38.3-19.2,72.8-15.3,76.6c1.9,1.9,199.3,128.4,436.8,277.8c237.6,149.4,446.4,285.5,465.6,302.7c76.6,67.1,21.1,226.1-134.1,383.2C3086.6-1444.6,2941-1408.3,2860.5-1517.5z"/>
											<path
												d="M850.7-2663.2c-70.9-42.1-105.4-459.8-55.6-670.6c101.6-425.4,431.1-714.7,873.7-764.5c149.4-17.2,408.1,3.8,492.4,38.3c67.1,26.8,90,101.6,51.7,168.6c-26.8,47.9-38.3,49.8-237.6,61.3c-243.3,13.4-385.1,55.6-544.1,164.8c-249.1,172.4-385.1,450.3-385.1,795.1c0,149.4-3.8,168.6-42.2,195.4C956-2640.2,898.6-2636.4,850.7-2663.2z"/>
											<path fill="#333333"
											      d="M168.6-2715c-72.8-139.9-92-680.2-36.4-913.9c113.1-457.9,367.9-793.2,749.2-979.1c270.2-134.1,427.3-168.6,758.7-168.6c208.8,1.9,310.4,9.6,411.9,36.4l134.1,36.4l5.7,90.1c7.7,128.4-32.6,151.3-226.1,128.4c-162.9-19.2-413.9,3.8-574.8,51.7c-358.3,105.4-666.8,362.1-843,701.3c-122.6,233.8-157.1,396.6-157.1,724.2c0,162.9-7.7,287.4-19.2,302.7C341-2669,189.6-2676.6,168.6-2715z"/>
										</g>
									</g>
								</svg>
						</div>
						<div className={'navlink'} style={{width: '80px', position: 'relative', top: '-14px', left: '35px'}}>
							<SatSlider
								satSliderCallback={callbackSatSlider}
							>
							</SatSlider>
						</div>
					</div>
						<div className={'navlink1'} style={{width: 'auto', paddingLeft: '60px'}}></div>
						<div className={'navlink1'} style={{fontWeight: language === 'IT' ? 700 : 450 }} onClick={()=>handleLangChange('IT')}>IT</div>
						<div className={'navlink1'} style={{fontWeight: language === 'EN' ? 700 : 450 }} onClick={()=>handleLangChange('EN')}>EN</div>
						<div className={'navlink1'} style={{fontWeight: language === 'DE' ? 700 : 450 }} onClick={()=>handleLangChange('DE')}>DE</div>
						<div
							onClick={()=>setShowVersion(!showVersion)}
							style={{width: '60px', paddingLeft:'60px', color:'lightgrey'}}
						>
							.
							{showVersion && <Version></Version>}
						</div>
				</div>
			</div>

			{props.showLegend &&

				<div className={'legendContainer'} style={{}}>

					<div className={'legendCircle'} style={{
						backgroundColor: useStore.getState().colors_desc,
						borderColor: stroke_desc,
//					borderColor: (useStore.getState().opacity_desc_hex)
					}}>
						<div className={'legendItem'} onClick={() => setCol1()}>{t('details available')}</div>
					</div>

					{/*				<div className={'legendCircle'} style={{*/}
					{/*					backgroundColor: useStore.getState().colors_sel,*/}
					{/*//					borderColor: useStore.getState().stroke_sel*/}
					{/*					borderColor: stroke_sel*/}
					{/*				}}>*/}
					{/*					<div className={'legendItem'} onClick={() => setCol1()}>ausgewählt</div>*/}
					{/*				</div>*/}

					{selected > 0 &&
						<>
							{(selected === 1 || selected === 2) &&
								<div className={'legendBox'} style={{backgroundColor: colors1}}>
									<div className={'legendItem'} onClick={() => setCol1()}>{t('planned')}</div>
								</div>
							}
							{(selected === 1 || selected === 2) &&
								<div className={'legendBox'} style={{backgroundColor: colors2}}>
									<div className={'legendItem'} onClick={() => setCol1()}>{t('started')}</div>
								</div>
							}
							{(selected === 1 || selected === 2) &&
								<div className={'legendBox'} style={{backgroundColor: colors3}}>
									<div className={'legendItem'} onClick={() => setCol1()}>{t('built')}</div>
								</div>
							}
							{/*<div className={'legendBox'} style={{backgroundColor: colors0}}>*/}
							{/*	<div className={'legendItem'} onClick={() => setColAll()}>anderer Baufortschritt</div>*/}
							{/*</div>*/}
						</>
					}
					{selected === 0 &&
						<>
							<div className={'legendBox'} style={{backgroundColor: colors_notbuilt}}>
								<div className={'legendItem'} onClick={() => setColNone()}>{t('built')}</div>
							</div>
							<div className={'legendBox'} style={{backgroundColor: colors_built}}>
								<div className={'legendItem'} onClick={() => setColNone()}>{t('started or built')}
								</div>
							</div>
						</>
					}
				</div>
			}

			{show !== '' &&
				<div className={'fulloverlay'}>
					<div className={'closeButton'} onClick={() => setShow('')}>&#10005;</div>
					{show === 'intro' &&
						<div className={'contentContainer contentbox'}>
							<h3>{t('intro')}</h3>
							<Intro />
						</div>
					}
					{show === 'background' &&
						<div className={'contentContainer contentbox'}>
							<Background />
						</div>
					}
					{show === 'help' &&
						<div className={'contentContainer contentbox'}>
							<h3>{t('help')}</h3>
							<Help />
						</div>
					}
					{show === 'impressum' &&
						<div className={'contentContainer contentbox'}>
							<h3>{t('impressum')}</h3>
							<Impressum />
						</div>
					}
				</div>
			}
		</>
	)
}
//)


export default LegendAndControl;

